var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"template",staticClass:"object",style:({ top: _vm.top + _vm.tankSize.height/2 + 'px', left:_vm.left + _vm.tankSize.width/2 + 'px', display: _vm.isShooting ? 'block' : 'none', })},[_c('i',{staticClass:"fas fa-tree"})])
}
var staticRenderFns = []

export { render, staticRenderFns }